import React from "react";
import Header from "../../components/Header/Header";
import SideBar from "../../components/SideBar/AdminSideBar";
import { Link } from "react-router-dom";
import {
  dashicon01,
  dashicon03,
  dashicon04,
} from "../../components/imagepath";
import Footer from "../../components/Footer/Footer";
import { hooks } from "../../components/../studentportal-sdk";
/* eslint-disable */
const AdminDashboard = (props) => {
  // Existing chart configurations and states
  // const options = {
  //   chart: {
  //     type: "pie",
  //   },
  //   plotOptions: {
  //     radialBar: {
  //       dataLabels: {
  //         name: {
  //           fontSize: "22px",
  //         },
  //         value: {
  //           fontSize: "16px",
  //         },
  //         total: {
  //           show: true,
  //           label: "Total",
  //           formatter: function (w) {
  //             // Calculate the total of the series
  //             return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
  //           },
  //         },
  //       },
  //     },
  //   },
  //   labels: [
  //     "Randburg Group",
  //     "Sandton Group",
  //     "Limpopo Group",
  //     "Midrand Group",
  //   ],
  // };

  // const series = [44, 55, 67, 83];
  // const [data, setObject] = useState({
  //   plotOptions: {
  //     radialBar: {
  //       dataLabels: {
  //         name: {
  //           fontSize: "22px",
  //         },
  //         value: {
  //           fontSize: "16px",
  //         },
  //         total: {
  //           show: true,
  //           label: "Total",
  //           formatter: function (w) {
  //             return 249;
  //           },
  //         },
  //       },
  //     },
  //   },
  //   chart: {
  //     height: 350,
  //     type: "radialBar",
  //     toolbar: {
  //       show: true,
  //     },
  //     fill: false,
  //   },
  //   dataLabels: {
  //     enabled: false,
  //   },
  //   datasets: {
  //     id: "apaxcharts-line",
  //   },
  //   colors: ["#3D5EE1", "#70C4CF"],
  //   borderWidth: 3,
  //   labels: ["Sandton Group", "Randburg Group", "Midrand Group"],
  // });

  // // Student Chart
  // const [dataBar, object] = useState({
  //   colors: ["#3D5EE1", "#70C4CF"],
  //   chart: {
  //     type: "pie",
  //     height: 350,
  //     width: "100%",
  //     stacked: false,
  //     toolbar: {
  //       show: false,
  //     },
  //   },
  //   dataLabels: {
  //     enabled: false,
  //   },
  //   plotOptions: {
  //     bar: {
  //       horizontal: false,
  //       columnWidth: "55%",
  //       endingShape: "rounded",
  //       categoryGap: "30%",
  //     },
  //   },
  //   stroke: {
  //     show: true,
  //     width: 2,
  //     colors: ["transparent"],
  //   },
  //   series: [
  //     {
  //       name: "Boys",
  //       color: "#70C4CF",
  //       data: [420, 532, 516, 575, 519, 517, 454, 392, 262, 383, 446, 551],
  //     },
  //     {
  //       name: "Girls",
  //       color: "#3D5EE1",
  //       data: [336, 612, 344, 647, 345, 563, 256, 344, 323, 300, 455, 456],
  //     },
  //   ],
  //   options: {
  //     chart: {
  //       type: "bar",
  //       height: 350,
  //     },
  //     plotOptions: {
  //       bar: {
  //         horizontal: false,
  //         columnWidth: "55%",
  //         endingShape: "rounded",
  //       },
  //     },
  //     dataLabels: {
  //       enabled: false,
  //     },
  //     stroke: {
  //       show: true,
  //       width: 2,
  //       colors: ["transparent"],
  //     },
  //     xaxis: {
  //       labels: {
  //         show: false,
  //       },
  //       axisBorder: {
  //         show: false,
  //       },
  //       axisTicks: {
  //         show: false,
  //       },
  //     },
  //     yaxis: {
  //       axisBorder: {
  //         show: false,
  //       },
  //       axisTicks: {
  //         show: false,
  //       },
  //       labels: {
  //         style: {
  //           colors: "#777",
  //         },
  //       },
  //     },
  //     title: {
  //       text: "",
  //       align: "left",
  //       style: {
  //         fontSize: "18px",
  //       },
  //     },
  //   },
  // });

  // const [studentchart] = useState([
  //   {
  //     name: "Boys",
  //     type: "column",
  //     data: [
  //       420, 532, 516, 575, 519, 517, 454, 392, 262, 383, 446, 551, 563, 421,
  //       563, 254, 452,
  //     ],
  //   },
  //   {
  //     name: "Girls",
  //     type: "column",
  //     data: [
  //       336, 612, 344, 647, 345, 563, 256, 344, 323, 300, 455, 456, 526, 652,
  //       325, 425, 436,
  //     ],
  //   },
  // ]);

  const {
    userService: {
      store: { users, authUser, students },
    },
    courseService: {
      store: {courseDocs}
    },
    liveSessionService: {
      store:{liveClassDoc}
    },
    assessmentService: {
      store:{assessmentDocs}
    },
  } = props;

  // **New State for Notice Board**
  // const [notices, setNotices] = useState([
  //   {
  //     id: 1,
  //     title: "New Training Modules Available",
  //     description: "Check out the latest training modules in the portal.",
  //     date: "2024-04-10",
  //   },
  //   {
  //     id: 2,
  //     title: "Maintenance Downtime",
  //     description: "The system will be down for maintenance on 2024-04-15.",
  //     date: "2024-04-08",
  //   },
  //   {
  //     id: 3,
  //     title: "Welcome New Managers",
  //     description: "Join us in welcoming our new Managers.",
  //     date: "2024-04-05",
  //   },
  // ]);

  const role = localStorage.getItem('role')

  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header {...authUser} />

        {/* Sidebar */}
        {role === "admin" && <SideBar />
}

        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <div className="page-sub-header">
                    <h3 className="page-title">Welcome Admin!</h3>
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/admindashboard">Home</Link>
                      </li>
                      <li className="breadcrumb-item active">Admin</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* /Page Header */}

            {/* Overview Section */}
            <div className="row">
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
                <div className="card bg-comman w-100">
                  <div className="card-body">
                    <div className="db-widgets d-flex justify-content-between align-items-center">
                      <div className="db-info">
                        <h6>Total Users</h6>
                        {users &&<h3>{users.length}</h3>}
                      </div>
                      <div className="db-icon">
                        <img src={dashicon01} alt="Dashboard Icon" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12 d-flex">
                <div className="card bg-comman w-100">
                  <div className="card-body">
                    <div className="db-widgets d-flex justify-content-between align-items-center">
                      <div className="db-info">
                        <h6>Admin</h6>
                        {(users && students) &&<h3>{users.length - students.length}</h3>}
                      </div>
                      <div className="db-icon">
                        <img src={dashicon01} alt="Dashboard Icon" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12 d-flex">
                <div className="card bg-comman w-100">
                  <div className="card-body">
                    <div className="db-widgets d-flex justify-content-between align-items-center">
                      <div className="db-info">
                        <h6>Students</h6>
                        {students &&<h3>{students.length}</h3>}
                      </div>
                      <div className="db-icon">
                        <img src={dashicon01} alt="Dashboard Icon" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12 d-flex">
                <div className="card bg-comman w-100">
                  <div className="card-body">
                    <div className="db-widgets d-flex justify-content-between align-items-center">
                      <div className="db-info">
                        <h6>Total Courses</h6>
                        {courseDocs &&<h3>{courseDocs.length}</h3>}
                      </div>
                      <div className="db-icon">
                        <img src={dashicon03} alt="Dashboard Icon" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12 d-flex">
                <div className="card bg-comman w-100">
                  <div className="card-body">
                    <div className="db-widgets d-flex justify-content-between align-items-center">
                      <div className="db-info">
                        <h6>Total Training Session</h6>
                        {liveClassDoc &&<h3>{liveClassDoc.length}</h3>}
                      </div>
                      <div className="db-icon">
                        <img src={dashicon03} alt="Dashboard Icon" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12 d-flex">
                <div className="card bg-comman w-100">
                  <div className="card-body">
                    <div className="db-widgets d-flex justify-content-between align-items-center">
                      <div className="db-info">
                        <h6>Total Assessments</h6>
                        {assessmentDocs && <h3>{assessmentDocs.length}</h3>}
                      </div>
                      <div className="db-icon">
                        <img src={dashicon04} alt="Dashboard Icon" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Overview Section */}

            {/* Notice Board Section */}
            {/* <div className="row mb-4">
              <div className="col-md-12">
                <div className="card flex-fill comman-shadow">
                  <div className="card-header d-flex align-items-center justify-content-between">
                    <h5 className="card-title">Notice Board</h5>
                    <ul className="chart-list-out student-ellips">
                      <li className="star-menus">
                        <Link to="#">
                          <i className="fas fa-ellipsis-v" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="card-body">
                    <ul className="notice-list">
                      {notices.map((notice) => (
                        <li key={notice.id} className="notice-item mb-4">
                          <h6 className="notice-title font-semibold text-lg">
                            {notice.title}
                          </h6>
                          <p className="notice-description text-gray-600">
                            {notice.description}
                          </p>
                          <span className="notice-date text-sm text-gray-500">
                            {notice.date}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div> */}
            {/* /Notice Board Section */}

            {/* Students and Recent Activity Section */}
            {/* <div className="row">
              <div className="col-xl-6 d-flex">
                <div className="card flex-fill student-space comman-shadow">
                  <div className="card-header d-flex align-items-center justify-content-between">
                    <h5 className="card-title">Students</h5>
                    <ul className="chart-list-out student-ellips">
                      <li className="star-menus">
                        <Link to="#">
                          <i className="fas fa-ellipsis-v" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table star-student table-hover table-center table-borderless table-striped">
                        <thead className="thead-light">
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th className="text-center">Level</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-nowrap">
                              <div>PRE2209</div>
                            </td>
                            <td className="text-nowrap">
                              <Link to="/profile" className="flex items-center">
                                <img
                                  className="rounded-circle mr-2"
                                  src={avatar02}
                                  width={25}
                                  alt="Star Students"
                                />
                                John Smith
                              </Link>
                            </td>
                            <td className="text-center">1185</td>
                          </tr>
                          <tr>
                            <td className="text-nowrap">
                              <div>PRE1245</div>
                            </td>
                            <td className="text-nowrap">
                              <Link to="/profile" className="flex items-center">
                                <img
                                  className="rounded-circle mr-2"
                                  src={avatar01}
                                  width={25}
                                  alt="Star Students"
                                />
                                Jolie Hoskins
                              </Link>
                            </td>
                            <td className="text-center">1195</td>
                          </tr>
                          <tr>
                            <td className="text-nowrap">
                              <div>PRE1625</div>
                            </td>
                            <td className="text-nowrap">
                              <Link to="/profile" className="flex items-center">
                                <img
                                  className="rounded-circle mr-2"
                                  src={avatar03}
                                  width={25}
                                  alt="Star Students"
                                />
                                Pennington Joy
                              </Link>
                            </td>
                            <td className="text-center">1196</td>
                          </tr>
                          <tr>
                            <td className="text-nowrap">
                              <div>PRE2516</div>
                            </td>
                            <td className="text-nowrap">
                              <Link to="/profile" className="flex items-center">
                                <img
                                  className="rounded-circle mr-2"
                                  src={avatar04}
                                  width={25}
                                  alt="Star Students"
                                />
                                Millie Marsden
                              </Link>
                            </td>
                            <td className="text-center">1187</td>
                          </tr>
                          <tr>
                            <td className="text-nowrap">
                              <div>PRE2209</div>
                            </td>
                            <td className="text-nowrap">
                              <Link to="/profile" className="flex items-center">
                                <img
                                  className="rounded-circle mr-2"
                                  src={avatar05}
                                  width={25}
                                  alt="Star Students"
                                />
                                John Smith
                              </Link>
                            </td>
                            <td className="text-center">1185</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 d-flex">
                <div className="card flex-fill comman-shadow">
                  <div className="card-header d-flex align-items-center justify-content-between">
                    <h5 className="card-title">Recent Activity</h5>
                    <ul className="chart-list-out student-ellips">
                      <li className="star-menus">
                        <Link to="#">
                          <i className="fas fa-ellipsis-v" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="card-body">
                    <div className="activity-groups">
                      <div className="activity-awards mb-4 flex items-start">
                        <div className="award-boxs mr-4">
                          <img
                            src={awardicon01}
                            alt="Award"
                            className="w-8 h-8"
                          />
                        </div>
                        <div className="award-list-outs flex-1">
                          <h4 className="text-md font-semibold">
                            1st place in "Chess”
                          </h4>
                          <h5 className="text-gray-600">
                            John Doe won 1st place in "Chess"
                          </h5>
                          <span className="notice-date text-sm text-gray-500">
                            1 Day ago
                          </span>
                        </div>
                      </div>
                      <div className="activity-awards mb-4 flex items-start">
                        <div className="award-boxs mr-4">
                          <img
                            src={awardicon02}
                            alt="Award"
                            className="w-8 h-8"
                          />
                        </div>
                        <div className="award-list-outs flex-1">
                          <h4 className="text-md font-semibold">
                            Participated in "Carrom"
                          </h4>
                          <h5 className="text-gray-600">
                            Justin Lee participated in "Carrom"
                          </h5>
                          <span className="notice-date text-sm text-gray-500">
                            2 hours ago
                          </span>
                        </div>
                      </div>
                      <div className="activity-awards mb-4 flex items-start">
                        <div className="award-boxs mr-4">
                          <img
                            src={awardicon03}
                            alt="Award"
                            className="w-8 h-8"
                          />
                        </div>
                        <div className="award-list-outs flex-1">
                          <h4 className="text-md font-semibold">
                            International Conference at "St.John School"
                          </h4>
                          <h5 className="text-gray-600">
                            Justin Lee attended international conference at
                            "St.John School"
                          </h5>
                          <span className="notice-date text-sm text-gray-500">
                            2 Weeks ago
                          </span>
                        </div>
                      </div>
                      <div className="activity-awards flex items-start">
                        <div className="award-boxs mr-4">
                          <img
                            src={awardicon04}
                            alt="Award"
                            className="w-8 h-8"
                          />
                        </div>
                        <div className="award-list-outs flex-1">
                          <h4 className="text-md font-semibold">
                            Won 1st place in "Chess"
                          </h4>
                          <h5 className="text-gray-600">
                            John Doe won 1st place in "Chess"
                          </h5>
                          <span className="notice-date text-sm text-gray-500">
                            3 Days ago
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
          {/* Footer */}
          <Footer />
        </div>
      </div>
      {/* /Main Wrapper */}
    </>
  );
};

export default (props) => <AdminDashboard {...hooks.UserManagement(props)} />;